function unwrapHeadingValue(value) {
    let current = value;
    let depth = 0;

    while (
        current &&
        typeof current === 'object' &&
        !Array.isArray(current) &&
        Object.prototype.hasOwnProperty.call(current, 'value') &&
        depth < 10
    ) {
        current = current.value;
        depth += 1;
    }

    return current;
}

export function hasHeadingContent(value) {
    const unwrapped = unwrapHeadingValue(value);
    if (typeof unwrapped === 'boolean') return unwrapped;
    return unwrapped != null && String(unwrapped).trim().length > 0;
}

export function getExplicitHeadingLevel(value) {
    const unwrapped = unwrapHeadingValue(value);
    if (unwrapped == null || typeof unwrapped === 'boolean') return null;

    const text = String(unwrapped).trim();
    const markdownMatch = text.match(/^(#{1,6})\s+/);
    if (markdownMatch) return markdownMatch[1].length;

    const htmlMatch = text.match(/^<h([1-6])(?:\s|>)/i);
    return htmlMatch ? Number(htmlMatch[1]) : null;
}

export function getChildHeadingVariant(parentHeading, parentLevel = 2) {
    const normalizedParentLevel = Math.min(
        6,
        Math.max(1, Number(parentLevel) || 2)
    );
    const effectiveParentLevel =
        getExplicitHeadingLevel(parentHeading) || normalizedParentLevel;
    const childLevel = hasHeadingContent(parentHeading)
        ? Math.min(effectiveParentLevel + 1, 6)
        : normalizedParentLevel;

    return `h${childLevel}`;
}
